export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12893.2bb85f69.jpg";